import SettingsContent from '../Wrapper';
import Index from './Index.vue';
import BulkActionReport from './BulkActionReport.vue';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
    routes: [
        {
            path: frontendURL('accounts/:accountId/settings/bulk-actions'),
            component: SettingsContent,
            props: {
                headerTitle: 'SIDEBAR.BULK_ACTIONS',
                icon: 'automation',
                showBackButton: true,
                backUrl: { name: 'settings_applications' },
                showNewButton: false,
            },
            children: [
                {
                    path: '',
                    name: 'bulk_actions_wrapper',
                    redirect: 'list',
                },
                {
                    path: 'list',
                    name: 'bulk_actions_list',
                    component: Index,
                    roles: ['administrator', 'supervisor'],
                },
                {
                    path: 'report/:bulkActionId',
                    name: 'bulk_actions_report',
                    component: BulkActionReport,
                    roles: ['administrator', 'supervisor'],
                },
            ],
        },
    ],
};
